import { render } from "./Backstage.vue?vue&type=template&id=f91c7d9e&scoped=true"
import script from "./Backstage.vue?vue&type=script&lang=js"
export * from "./Backstage.vue?vue&type=script&lang=js"

import "./Backstage.vue?vue&type=style&index=0&id=f91c7d9e&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f91c7d9e"]])

export default __exports__